import { pageVisitRecord } from '@/api/config';

export default {
    methods: {
        pageVisitRecord(page, parentId, pageName, functionDomain, type) {
            pageVisitRecord({
                action: 1,
                clientType: 1,
                browserInfo: navigator.userAgent,
                // functionDomain 2001门户 2002农技资源 1000 1001 1002 1003 1004管理平台
                functionDomain,
                page,
                pageName,
                parentId,
                // type 1 栏目 2 菜单（权限） 3 按钮（权限） 4 自定义按钮 5 农技菜单"
                type
            }).then(() => {})
        }
    }
}